import { Component, Injector } from '@angular/core';
import { WorkOrderNotificationService, WorkOrderService } from '../../ve.service';
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { Validators } from '@angular/forms';
import { FilterableService } from '../../../../shared/filterable-service';

@Component({
  selector: 'app-default-notification-contacts',
  templateUrl: '../base-grid/base-grid.component.html',
})
export class DefaultNotificationContactsComponent extends BaseGridComponent {
  private readonly contactsFilterableService = new FilterableService();
  private readonly WorkOrderService: WorkOrderService;
  private readonly WOFilterableService = new FilterableService();

  constructor(
    cgpConfirmationDialogService: CgpConfirmationDialogService,
    cgpSnackbarService: CgpSnackbarService,
    service: WorkOrderNotificationService,
    injector: Injector,
  ) {
    super(cgpConfirmationDialogService, cgpSnackbarService, service, injector);
    this.WorkOrderService = injector.get(WorkOrderService);

    this.path = '/Module/' + this.adminService.userModule;
    this.appCardTitle = 'Default Notification Contacts';

    this.columns = [
      {
        field: 'WorkOrderStatusDescription',
        title: 'Status',
        type: 'dropdown',
        service: this.WOFilterableService,
        textField: 'Description',
        valueField: 'Id',
        name: 'WorkOrderStatusId',
        isEditingDisabled: true,
        isEditingDisabledColumn: 'WorkOrderStatusDescription',
        refreshSecondaryData: this.populateWorkOrderStatusList,
      },
      {
        field: 'ContactList',
        title: 'Contacts',
        type: 'multiselect_simple',
        service: this.contactsFilterableService,
        name: 'ContactList',
        refreshSecondaryData: this.populateContactsList,
      },
    ];

    this.editForm = this.formBuilder.group({
      Id: [],
      ContactList: [],
      WorkOrderStatusDescription: [],
      WorkOrderStatusId: ['', Validators.required],
      ModuleName: [],
      ModuleDescription: [],
      ModuleId: [],
      AuditDto: []
    });
  }

  populateWorkOrderStatusList(dataItem: any) {
    dataItem.WorkOrderService.read('/GetUnusedStatusesByModule/' + dataItem.adminService.userModule)
    .then(result => {
      if (result) {
        if (result.length > 0) {
          result.sort();
        }

        for (let i = result.length - 1; i >= 0; i--) {
          if (result[i].Description.toLowerCase() === 'draft') {
            result.splice(i, 1);
          }
        }

        dataItem.WOFilterableService.next(result);
      }
    });
  }

  populateContactsList(dataItem: any) {
    dataItem.service.read('/ContactsForModule/' + dataItem.adminService.userModule)
      .then(result => {
        if (result.length > 0) {
          result.sort();
        }
        dataItem.contactsFilterableService.next(result);
      });
  }
}
